module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_c('h2', {
    staticClass: "main-headline"
  }, [_vm._v("YOUR PROJECT. YOUR VISION.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "back-button",
    attrs: {
      "tag": "a",
      "to": "/products"
    }
  }, [_vm._v("\n                        Back to products\n                    ")]), _vm._v(" "), _vm._m(1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subheadline"
  }, [_vm._v("With over 30+ years of experience, Fund Raisers, Ltd. has hand selected each "), _c('br'), _vm._v("\n                        product to ensure that you receive only the best in the industry with the right "), _c('br'), _vm._v("\n                    balance of quality, aesthetics, and affordability.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fonts"
  }, [_c('div', {
    staticClass: "fonts-left"
  }, [_c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v(" FONT OPTIONS")]), _vm._v(" "), _c('strong', [_vm._v("Frutiger Font (Recommended)")]), _vm._v(" "), _c('p', [_vm._v("This classic, clean font is our most popular style, used for all occasions,\n                       and works with all material options. ")]), _vm._v(" "), _c('div', {
    staticClass: "fonts-bricks-hidden"
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/fontsfrutiger.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Frutiger Font")])]), _vm._v(" "), _c('strong', [_vm._v("Univers Font")]), _vm._v(" "), _c('p', [_vm._v("This taller, leaner, and more compact font is our most popular style for\n                       military organizations and allows for more characters per line. ")]), _vm._v(" "), _c('div', {
    staticClass: "fonts-bricks-hidden"
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/fontsunivers.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Univers Font")])]), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("ENGRAVING & FILLER SPECIFICATIONS")]), _vm._v(" "), _c('p', [_vm._v("Each brick size has a maximum number of lines available for engraving\n                        and is filled with Fund Raisers, Ltd., proprietary Light filler. Our\n                        proprietary filler has been tested to withstand cracking and chipping\n                        under normal wear and tear, ensuring each heartfelt message lasts a\n                    lifetime. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("4” x 8” Bricks ")]), _vm._v(" - up to 3 lines of text "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("8” x 8” Bricks ")]), _vm._v(" - up to 6 lines of text "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("12” x 12” Bricks ")]), _vm._v(" - up to 10 lines of text")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("Please note that bricks using symbols or logos will reduce the number of lines\n                        available for engraving.")])]), _vm._v(" "), _c('div', {
    staticClass: "fonts-right"
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/fontsfrutiger.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Frutiger Font")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/Products-Page/fontsunivers.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Univers Font")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-520c2efa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Fonts.vue
// module id = H1S5
// module chunks = 1